import { MultipleRuleBuildersProvider } from '../../common/sweep-condition-rule-builder/MultipleRuleBuildersContext';
import DedupMatching from '../dedup-and-matching/DedupMatching';
import {
  ConfigurationCanvasLeftPanel,
  ConfigurationCanvasPanelHeader,
  ConfigurationCanvasPanelContent,
} from '../configuration-canvas-panel';
import { GlobalRenderer } from '../global-renderer/GlobalRenderer';

export const DedupAndMatchingPage = () => {
  return (
    <GlobalRenderer>
      <ConfigurationCanvasLeftPanel withExpandedModeButton={true}>
        <ConfigurationCanvasPanelHeader withExpandedModeButton={true}>
          Dedupe & Matching
        </ConfigurationCanvasPanelHeader>
        <ConfigurationCanvasPanelContent
          sx={{
            overflow: 'hidden',
            height: '100%',
            padding: 0, //needed in order to override the existing value (I dont know who needs it)
            display: 'flex',
          }}
        >
          <MultipleRuleBuildersProvider>
            <DedupMatching />
          </MultipleRuleBuildersProvider>
        </ConfigurationCanvasPanelContent>
      </ConfigurationCanvasLeftPanel>
    </GlobalRenderer>
  );
};
